import React from 'react'
import { STATUS } from 'state/requestStatus/reducer';

class VotePrefBase extends React.Component {
  votePrefKey(pageAuthorId, props) {
    const { pageId } = props || this.props;
    return `${pageAuthorId}#${pageId}`;
  }

  pageFriendlyName(props) {
    // this splits on '-' and uppercases the first non-whitespace
    // character of all words in a string
    return props.pageId
      .replace(/[-_]/g, " ")
      .replace(/\b\S/g, (chr) => chr.toUpperCase());
  }

  // pulld user id (the author) from the URL
  getAuthorId (props) {
    return (props || this.props).match.params.userId;
  }

  getCurrentUser (props) {
    return (props || this.props).user;
  }

  /**
   * Returns the userId from the URL, if it exists, else it
   * returns the authed userId, if authed (IN THIS ORDER).
   * This handles the different ways user can be represented
   * in the props;
   */
  urlOrAuthUserId(props) {
    const { user } = props || this.props;
    const urlUserId = this.getAuthorId(props);
    if (urlUserId) {
      return urlUserId;
    }
    if (user && user.data && user.data.userId) {
      return user.data.userId;
    }
    if (user && user.userId) {
      return user.userId;
    }
    return null;
  }

  getVotePref(pageAuthorId, props) {
    const { votePrefs } = props || this.props;
    const key = this.votePrefKey(pageAuthorId, props);
    const votePref = votePrefs[key] || { data: {} };
    return votePref;
  }

  votePrefIsLoading(pageAuthorId, props) {
    const votePref = this.getVotePref(pageAuthorId, props);
    const status = votePref.status;
    // states are ordered by flags in an asceding order or request state
    // pending state is the final of the possible pending states, which
    // are loading, deleting, etc. after that is saved, deleted, etc,
    // completed
    if (status !== STATUS.NONE && status > STATUS.PENDING) {
      return false;
    }
    return true;
  }

  pageOwnerFriendlyName(userId, possessive=true, props) {
    const votePref = this.getVotePref(userId, props);
    if (this.viewerIsPageOwner(userId, props)) {
      return "My";
    }
    if (!votePref || !votePref.user) {
      return "My";
    }
    const { user } = votePref;
    let name = user.first;
    if (user.name) {
      name = `${user.name}`;
    }
    if (possessive) {
      return `${name}'s`;
    }
    return name;
  }

  /**
   * This checks to see if the currently logged in user (is any)
   * is the vote pref or ballot page owner, by a passed in owner ID.
   * This works for both vote pref and ballot pages, as long as
   * you make sure to pass the resource ID, not the authed user ID.
   */
  viewerIsPageOwner(pageAuthorId, props) {
    const { user } = props || this.props;
    if (!user) {
      return false;
    }
    if (user.data && user.data.userId === pageAuthorId) {
      return true;
    }
    if (user.userId === pageAuthorId) {
      return true;
    }
    return false;
  }

  /**
   * Check is the user is logged in, by checking the
   * state tree.
   */
  isAuthed(props) {
    const { auth, user } = props || this.props;
    if (!auth || !user) {
      return false;
    }
    if (auth.loggedIn === true) {
      return true;
    }
    return false;
  }

  /**
   * Checks to see if the currently logged in user can interact
   * with the vote pref controls on the curently displayed page.
   * This is allowed if the current user is the proposed
   * pref owner (in the case that the vote pref hasn't been
   * created yet) or is the pref exists (since no vote pref
   * will be returned if the backend fails the security
   * checks, assuming it exists).
   */
  votePrefIsAccessible(props) {
    const currentPageUserId = this.getAuthorId(props);
    const currentUser = this.getCurrentUser(props);
    const votePref = this.getVotePref(currentPageUserId);
    if (currentUser && currentPageUserId === currentUser.userId) {
      return true;
    }
    if (votePref && votePref.user) {
      return true;
    }
    return false;
  }
}

export default VotePrefBase;



// WEBPACK FOOTER //
// ./src/components/interactive/votePref/VotePrefBase.js